import { Button, Tooltip } from "@shopify/polaris";
import { RefreshIcon } from "@shopify/polaris-icons";

const RefreshButton = ({
  refetch,
  isLoading,
  tooltipContent,
}: {
  refetch: () => void;
  isLoading: boolean;
  tooltipContent: string;
}) => {
  return (
    <Tooltip content={tooltipContent}>
      <Button
        loading={isLoading}
        disabled={isLoading}
        onClick={() => {
          refetch();
        }}
        icon={RefreshIcon}
        accessibilityLabel="refresh order page"
      ></Button>
    </Tooltip>
  );
};

export default RefreshButton;
